import './assets/css/main.css'
import React from 'react'
import {Router} from 'react-router-dom'
import {createBrowserHistory} from 'history'
import {createAndInjectDynamicScript} from './helpers/addDynamicJS'
import {ChakraProvider} from '@chakra-ui/react'
import {initializeApp} from './initializeApp'
import App from './App'
import {createRoot} from 'react-dom/client'
import newTheme from './components/DesignSystem/styles/theme'
const browserHistory = createBrowserHistory({basename: ''})
const rootElement = document.getElementById('root')

initializeApp(browserHistory).then(config => {
  //TODO OneTrust script needs to be fixed
  // createAndInjectDynamicScript(document, {
  //   src: config.oneTrustScriptSrc,
  //   props: {['data-domain-script']: config.oneTrustScriptDataDomain},
  // })
  createRoot(rootElement).render(
    <Router basename="/enroll" history={browserHistory}>
      <ChakraProvider theme={newTheme}>
        <App appConfig={config} />
      </ChakraProvider>
    </Router>
  )
})
